module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAApklEQVRYR+2WwQ2AMAhFYRDdx0lMO1AbJ3EfHaTGg16amJCvhurvGejnQaEqzo861ycUiFaIBG8jmFIaVHUSkQ4NCvqvpZQxxjjvcc4S55wXB+KO3NYQQt+WQPclBvvmMXeOGRQtCZIgSgD1b6cH3Q9q7mJbM9afBfcltiX4nnU7r/g9JrabSNDGq7Ymwf8QdD+ouYttzchdbON1Yc05iKIkwc8T3AC1/1QpWxyJkAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Group.png
// module id = oBap
// module chunks = 1